//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------

//  -- Constants ----------------------
import { ActionTypes } from 'store/constants';


//  ----------------------------------------------------------------------------
//  Reducers
//  ----------------------------------------------------------------------------

//  -- Example ------------------------
const logsInitial = [];

export const class_user_logs = (state = logsInitial, action) => {
    switch (action.type) {
        case ActionTypes.logs.set_active_class_logs:
            return action.payload;
        case ActionTypes.logs.clear_active_class_log:
            return logsInitial;
        default:
            return state;
    }
};


const alertViewInit = {
    view:false,
    message:'',
    poster:''
};


export const messageAlertView = (state = alertViewInit, action) => {
    switch (action.type) {
        case ActionTypes.alert.invokeMessageAlert: {
            const payload = typeof action.payload === 'string'
                ? { message: action.payload, poster: '' }
                : action.payload;
            return ({
                view: true,
                message: payload.message || '',
                poster: payload.poster || ''
            });
        }
        case ActionTypes.alert.revokeMessageAlert:
            return ({ view: false, message: '', poster: '' });
        default:
            return state;
    }
};
